export const USER_OPEN_APP = 'user_open_app';
export const USER_CLICK_ON_REGISTER = 'user_click_on_register';
export const USER_CLICK_ON_REGISTER_IN_ONBOARDING = 'user_click_register_on_onboarding';
export const USER_INPUT_DOCUMENT_FIRST_TIME = 'user_input_document_first_time';
export const USER_VALIDATES_DOCUMENT = 'user_validates_document';
export const USER_SIGN_UP = 'user_sign_up';
export const USER_CLICK_ON_LOGIN = 'user_click_on_login';
export const USER_CLICK_ON_RESET_PASSWORD = 'user_click_on_reset_password';
export const USER_OPEN_HOME_SCREEN = 'user_open_home_screen';
export const USER_LIST_REFER_FRIENDS = 'user_list_refer_friends';
export const USER_REFER_FRIEND = 'user_refer_friend';
export const USER_OPEN_INSTALLMENT_PAYMENT = 'user_open_installment_payment';
export const USER_OPEN_REDEEM_PRIZE = 'user_open_redeem_prize';
export const USER_CLICK_ON_REDEEM_PRIZE = 'user_click_on_redeem_prize';
export const USER_OPEN_PAY_ON_TIME = 'user_open_pay_on_time';
export const USER_CLICK_GENERATE_BANK_SLIP = 'user_click_generate_bank_slip';

